import { yamadumiApi } from '../yamadumi-api'
import { UserProperty } from './UserProperty'

export class LoginGateway {
  static async login(): Promise<UserProperty> {
    const response = await yamadumiApi.post<UserProperty>('/api/common/login', undefined, { disableCommonErrorHandling: true })
    Object.setPrototypeOf(response.data, UserProperty.prototype)
    return response.data
  }
}
